module.exports = __webpack_public_path__ + "img/ícone-não-valido.ac89b17c.svg";